import React from 'react';
import { Grid, List, ListItem, ListItemText, Divider, Fab, ListItemSecondaryAction, Button } from '@material-ui/core';


import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import WsC from './providers/WsC';
import Utils from '../../providers/Utils';


export default class ListaRaspunsuri extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            raspunsNou: ''

        }
    }

    componentDidMount() {
    }

    insertRaspuns = () => {

    }
    render() {
        return (
            <div>
                <Grid container style={{ borderRadius: 16, position: 'relative', width: '100%' }}>
                    {/* <div>
                     {   (this.props.objIntrebareInfo.id_parent === null || this.props.objIntrebareInfo.id_parent === 0) &&
                        <Fab style={{ position: 'absolute', top: 6, right: 10 }} onClick={this.props.openRaspuns} className="chestionare-adauga-button">
                            <i className='material-icons chestionare-anuleaza-button-icon'>add</i>
                        </Fab>
                     }
                    </div> */}
                    <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>

                        <List className="chestionare-common-list" style={{ margin: 0 }}>



                            {
                                this.props.listaRaspunsuri.map((b, idx) => {
                                    return (
                                        <LiListaRaspunsuri key={'raspunsL' + idx}
                                            idx={idx}
                                            raspuns={b}
                                            onClick={this.props.goToRaspuns}
                                            objIntrebareInfo={this.props.objIntrebareInfo}
                                            delete={this.props.deleteRaspuns}
                                            deleteIcon={this.props.deleteIcon}
                                            rapoarte={this.props.rapoarte}
                                            changeRaspuns={this.props.changeRaspuns}
                                            updateRaspuns={this.props.updateRaspuns}
                                            objEvaluare={this.props.objEvaluare}
                                            getRaspunsuri={this.props.getRaspunsuri}
                                        />
                                    )
                                })
                            }
                            {(this.props.objIntrebareInfo.id_parent === null || this.props.objIntrebareInfo.id_parent === 0) && !this.props.noAdd &&
                                <div style={{ padding: 10 }}>
                                    <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 20 }} variant="contained" onClick={this.props.insertRaspuns} className='chestionare-adauga-raspuns-button'>
                                        {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Adauga raspuns
                                             </Button>

                                </div>
                            }

                            {(this.props.objIntrebareInfo.id_parent !== null && this.props.objIntrebareInfo.id_parent !== 0) &&

                                <div>
                                    {/* <span>test victor{console.log('this.props.objIntrebareInfo :', this.props.objIntrebareInfo) && this.props.objIntrebareInfo.id_parent}</span> */}
                                    <ListItem style={{ padding: 0 }}>
                                        {!this.props.objIntrebareInfo.tip.includes('img') && this.props.objIntrebareInfo.tip.indexOf('text') === -1 &&
                                            <span style={{ marginLeft: 10, display: 'flex', justifyContent: 'space-between', position: 'relative', width: '100%', marginBottom: 10 }}>


                                                <input
                                                    disabled={this.props.isTemplate}
                                                    style={{
                                                        width: '80%',
                                                        textAlign: 'left',
                                                        backgroundColor: 'transparent',
                                                        color: 'rgba(0, 0, 0, 0.87)',

                                                        lineHeight: 1,

                                                        margin: 0,
                                                        fontSize: 15,
                                                        fontFamily: 'inherit',
                                                        verticalAlign: 'text-top',

                                                        padding: 0
                                                    }}
                                                    onFocus={this.props.focusChange}
                                                    className='chestionare-task-time-input'
                                                    type='text'
                                                    value={this.props.nume || " "}
                                                    onChange={this.props.numeChange}
                                                />

                                                {!this.props.noAdd &&
                                                    <div style={{ padding: '5px 0 0 0' }} >
                                                        <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 20 }} variant="contained" onClick={() => { this.props.insertRaspuns() }} className='chestionare-adauga-raspuns-button'>
                                                            {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Adauga raspuns
                                             </Button>

                                                    </div>
                                                }



                                                {/* <i style={{ marginRight: 10, color: 'rgb(34,159,136)', fontSize: 20 }} className="material-icons chestionare-list-intrebari-icons">add</i> */}

                                                {/* <i onClick={()=>{this.props.deleteIntrebare(this.props.intrebare)}} style={{marginRight:0, color:'rgb(244,20,41)', fontSize:20}} className="material-icons chestionare-list-intrebari-icons">clear</i> */}

                                            </span>
                                        }


                                    </ListItem>
                                    <Divider className="crm-divider" />
                                </div>

                            }

                        </List>

                    </Grid>
                </Grid>
            </div>
        );
    }
}


class LiListaRaspunsuri extends React.Component {






    getInfoRaspuns = () => {
        //   console.log('this.props.raspuns :', this.props.raspuns);
        this.props.onClick(this.props.raspuns)
    }

    deleteRaspuns = () => {
        this.props.delete(this.props.raspuns)
    }


    getInputRaspuns = (r) => {

        console.log('r :>> ', r);
        document.getElementById(r).focus();


    }

    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadPoza = async (id, idRaspuns, bkId) => {


        console.log('idRaspuns :>> ', idRaspuns);
        let ws = new WsC();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

    

       



        reader.onload = async () => {
            let fileContent = reader.result;
            //  console.log(fileContent);
            console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/UpdatePozaRaspuns/?idRaspuns', saveFile, idRaspuns);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {


                this.props.getRaspunsuri()

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);


        }
    }




    render() {
        return (
            <div>
                {!this.props.objIntrebareInfo.tip.includes('img') && (this.props.objIntrebareInfo.id_parent === null || this.props.objIntrebareInfo.id_parent === 0) &&
                    <ListItem style={{ padding: 0 }} >

                        <Grid style={{ margin: '20px 0 20px 0' }} container>
                            <Grid item xs={10} sm={10} md={10} lg={10} xl={10} >
                                <Grid container>
                                    <Grid item xs={9} sm={9} md={9} lg={9} xl={9} >
                                        <span style={{ verticalAlign: 'sub' }}>{new Utils().alfabet[this.props.idx]})</span>
                                        {this.props.isTemplate ?
                                            <span style={{
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                fontSize: 15,
                                            }}>
                                                {this.props.raspuns.label}
                                            </span>

                                            :
                                            <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                <input

                                                    style={{
                                                        width: '90%',
                                                        textAlign: 'left',
                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                        textOverflow: 'ellipsis',
                                                        lineHeight: 1,

                                                        margin: 0,
                                                        fontSize: 15,
                                                        fontFamily: 'inherit',
                                                        verticalAlign: 'text-top',

                                                        padding: 10
                                                    }}
                                                    id={`raspunse${this.props.raspuns.id}`}
                                                    // onFocus={(e) => {
                                                    //     var val = e.target.value;
                                                    //     e.target.value = '';
                                                    //     e.target.value = val;
                                                    className='add-project-input'
                                                    type='text'
                                                    name='label'
                                                    value={this.props.raspuns.label || ""}
                                                    onChange={(ev) => { this.props.changeRaspuns(ev, this.props.raspuns) }}
                                                    onBlur={() => { this.props.updateRaspuns(this.props.raspuns) }} />
                                                <label className='inputLabelPM' htmlFor={`raspuns${this.props.raspuns.id}`}>Raspuns</label>
                                            </div>

                                        }


                                    </Grid>


                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                        {this.props.isTemplate ?
                                            <span style={{
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                fontSize: 15,
                                            }}>
                                                {this.props.raspuns.puncte || '0'}
                                            </span>

                                            :
                                            <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                <input

                                                    style={{
                                                        width: '80%',
                                                        textAlign: 'left',
                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                        textOverflow: 'ellipsis',
                                                        lineHeight: 1,

                                                        margin: 0,
                                                        fontSize: 15,
                                                        fontFamily: 'inherit',
                                                        verticalAlign: 'text-top',

                                                        padding: 10
                                                    }}
                                                    id={`raspunsepuncte${this.props.raspuns.id}`}
                                                    onFocus={(e) => {
                                                        var val = e.target.value;
                                                        e.target.value = '';
                                                        e.target.value = val;
                                                    }}
                                                    className='add-project-input'
                                                    placeholder={0}
                                                    type='text'
                                                    name='puncte'
                                                    value={this.props.raspuns.puncte || ""}
                                                    onChange={(ev) => { this.props.changeRaspuns(ev, this.props.raspuns) }}
                                                    onBlur={() => { this.props.updateRaspuns(this.props.raspuns) }} />
                                                <label className='inputLabelPM' htmlFor={`raspunspuncte${this.props.raspuns.id}`}>Puncte</label>
                                            </div>
                                        }
                                    </Grid>

                                </Grid>
                            </Grid>

                            {!this.props.isTemplate && this.props.objIntrebareInfo.tip !== 'grupaj' &&
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{ paddingTop: 10 }} >

                                    <TrashAltSolid className='textSecondary iconSvg' onClick={this.deleteRaspuns} style={{ marginRight: 10, width: 18, height: 18 }} />
                                    <i style={{ fontSize: 18 }} onClick={() => { this.getInputRaspuns(`raspunse${this.props.raspuns.id}`) }} className="material-icons iconFontSize textSecondary">edit</i>

                                    {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                </Grid>
                            }


                        </Grid>

                        {/* <ListItemText onClick={this.getInfoRaspuns} primary={


                            <h3 style={{ display: 'flex', justifyContent: 'space-between' }} className='chestionare-list-text'>
                                <span> {this.props.rapoarte ? (this.props.raspuns.label_rapoarte ? this.props.raspuns.label_rapoarte : this.props.raspuns.label) : this.props.raspuns.label}</span>
                                {this.props.objEvaluare.foloseste_puncte === 1 &&
                                    <span>{this.props.raspuns.puncte}</span>
                                }
                            </h3>}

                        /> */}



                    </ListItem>
                }





                {this.props.objIntrebareInfo.tip.includes('img') &&


                    <ListItem button  >



                        <Grid style={{ margin: '20px 0 20px 0' }} container>
                            <Grid item xs={10} sm={10} md={10} lg={10} xl={10} >
                                <Grid container>
                                    <Grid item xs={9} sm={9} md={9} lg={9} xl={9} >
                                        <span>{new Utils().alfabet[this.props.idx]})</span>
                                        {this.props.isTemplate ?
                                            <span style={{
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                fontSize: 15,
                                            }}>
                                                {this.props.raspuns.label}
                                            </span>

                                            :
                                            <div style={{display:"inline-block", verticalAlign:'middle'}}>
                                                <input type='file' id={`file-poza-raspuns${this.props.idx}`}
                                                    style={{ display: 'none' }}
                                                    accept='image/*'
                                                    onChange={() => { this.uploadPoza(`file-poza-raspuns${this.props.idx}`, this.props.raspuns.id, 'raspuns-image-view') }}
                                                />
                                                {this.props.raspuns.img_src !== null &&
                                                    <h3   onClick={() => { this.selectFile(`file-poza-raspuns${this.props.idx}`, ) }} style={{ display: 'flex', justifyContent: 'space-between' }} className='chestionare-list-text'>
                                                        <img alt={this.props.raspuns.img_src} style={{ maxWidth: 50 }} src={new WsC().adresaMedia + `/Chestionare/Raspunsuri_img/${this.props.raspuns.img_src}`} />
                                                        {this.props.objEvaluare.foloseste_puncte === 1 &&
                                                            <span>{this.props.raspuns.puncte}</span>
                                                        }
                                                    </h3>
                                                }
                                                {
                                                    this.props.raspuns.img_src === null &&


                                                    <h3   onClick={() => { this.selectFile(`file-poza-raspuns${this.props.idx}`) }} style={{ display: 'flex', justifyContent: 'space-between' }} className='chestionare-list-text'>
                                                        <i className='material-icons'>image</i>
                                                        {this.props.objEvaluare.foloseste_puncte === 1 &&
                                                            <span>{this.props.raspuns.puncte}</span>
                                                        }
                                                    </h3>

                                                }
                                            </div>

                                        }


                                    </Grid>


                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                                        {this.props.isTemplate ?
                                            <span style={{
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                fontSize: 15,
                                            }}>
                                                {this.props.raspuns.puncte || '0'}
                                            </span>

                                            :
                                            <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                <input

                                                    style={{
                                                        width: '80%',
                                                        textAlign: 'left',
                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                        textOverflow: 'ellipsis',
                                                        lineHeight: 1,

                                                        margin: 0,
                                                        fontSize: 15,
                                                        fontFamily: 'inherit',
                                                        verticalAlign: 'text-top',

                                                        padding: 10
                                                    }}
                                                    id={`raspunsepuncte${this.props.raspuns.id}`}
                                                    onFocus={(e) => {
                                                        var val = e.target.value;
                                                        e.target.value = '';
                                                        e.target.value = val;
                                                    }}
                                                    className='add-project-input'
                                                    placeholder={0}
                                                    type='text'
                                                    name='puncte'
                                                    value={this.props.raspuns.puncte || ""}
                                                    onChange={(ev) => { this.props.changeRaspuns(ev, this.props.raspuns) }}
                                                    onBlur={() => { this.props.updateRaspuns(this.props.raspuns) }} />
                                                <label className='inputLabelPM' htmlFor={`raspunspuncte${this.props.raspuns.id}`}>Puncte</label>
                                            </div>
                                        }
                                    </Grid>

                                </Grid>
                            </Grid>

                            {!this.props.isTemplate && this.props.objIntrebareInfo.tip !== 'grupaj' &&
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{ paddingTop: 10 }} >

                                    <TrashAltSolid className='textSecondary iconSvg' onClick={this.deleteRaspuns} style={{ marginRight: 10, width: 18, height: 18 }} />
                                    <i style={{ fontSize: 18 }} onClick={() => { this.selectFile(`file-poza-raspuns${this.props.idx}`) }} className="material-icons iconFontSize textSecondary">edit</i>

                                    {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                </Grid>
                            }


                        </Grid>







                    </ListItem>
                }


                <Divider className="crm-divider" />
            </div>
        )
    }
}





